// src/core/HttpClient.ts
import fetch from "cross-fetch";
import createError from "http-errors";
import defaultErrorHandler from "../utils/defaultErrorHandler.mjs";
import defaultResponseHandler from "../utils/defaultResponseHandler.mjs";
import defaultPreflightHandler from "../utils/defaultPreflightHandler.mjs";
import buildUrl from "../utils/buildUrl.mjs";
import browserFetch from "./browserFetch.mjs";
var HttpClient = class {
  constructor(opts = {}) {
    this.baseUrl = opts.baseUrl;
    this.fetchImpl = opts.fetchImpl ?? browserFetch ?? fetch;
    this.logger = opts.logger;
    this.errorHandler = opts.errorHandler ?? defaultErrorHandler;
    this.responseHandler = opts.responseHandler ?? defaultResponseHandler;
    this.preflightHandler = opts.preflightHandler ?? defaultPreflightHandler;
  }
  log(...args) {
    this.logger?.info(...args);
  }
  async makeRequest(url, opts) {
    try {
      const fetchUrl = buildUrl(url, this.baseUrl, opts.searchParams);
      const preflightArgs = {
        url: fetchUrl,
        options: opts
      };
      await this.preflightHandler(preflightArgs);
      this.log(`Outgoing ${opts.method} request: ${preflightArgs.url}`);
      const response = await this.fetchImpl(preflightArgs.url, preflightArgs.options).catch(
        async (err) => {
          const { handleOAuthFlow, body, ...httpOptions } = preflightArgs.options;
          if (!handleOAuthFlow) {
            throw err;
          }
          const danceOpts = {
            ...httpOptions,
            mode: "no-cors",
            method: "GET",
            credentials: "include"
          };
          this.log(`Making no-cors request: ${preflightArgs.url}`);
          await this.fetchImpl(preflightArgs.url, danceOpts);
          this.log(`no-cors request succeeded, making original request: ${preflightArgs.url}`);
          return await this.fetchImpl(preflightArgs.url, preflightArgs.options);
        }
      );
      if (response.status >= 400) {
        throw createError(response.status, response.statusText, { response });
      }
      return await this.responseHandler(response);
    } catch (err) {
      return await this.errorHandler(err);
    }
  }
  async get(url, opts = {}) {
    return await this.makeRequest(url, {
      ...opts,
      method: "GET"
    });
  }
  async post(url, opts) {
    return await this.makeRequest(url, {
      ...opts,
      method: "POST"
    });
  }
  async put(url, opts) {
    return await this.makeRequest(url, {
      ...opts,
      method: "PUT"
    });
  }
  async del(url, opts) {
    return await this.makeRequest(url, {
      ...opts,
      method: "DELETE"
    });
  }
  async patch(url, opts) {
    return await this.makeRequest(url, {
      ...opts,
      method: "PATCH"
    });
  }
};
export {
  HttpClient as default
};
